export const SUPPORTED_LOCALES = [
  'en-us',
  'en-gb',
  'en-sg',
  'es-mx',
  'es-es',
  'fr-fr',
  'de-de',
  'hi-in',
  'it-it',
  'ja-jp',
  'ko-kr',
  'zh-cn',
  'zh-tw',
  'vi-vn',
] as const;

export const DEFAULT_LOCALE = 'en-us' as const;
export const DEFAULT_SITE_NAME = 'Form Technologies';
export const DEFAULT_SHARE_IMAGE =
  'https://azure-na-images.contentstack.com/v3/assets/bltc3d459c709c6e7a5/bltbe37e282ea60ffda/Default Share';

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
